import { Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { en } from './i18n';

@Injectable({ providedIn: 'root' })
export class LanguageLoader implements TranslateLoader {
  private readonly _languages: Record<string, TranslationObject> = {
    en: en as TranslationObject,
  };

  getTranslation(lang: string): Observable<TranslationObject> {
    const dictionary = this._languages[lang] ?? this._languages['en'];
    return of(dictionary);
  }
}
